import * as services from './list'

export const allServices = Object.values(services).sort((previous, current) =>
    previous.name.localeCompare(current.name),
)
